import { AccordionDetails as AccordionDetailsMui, styled } from '@mui/material';
import theme, { COLOR_BORDER } from 'src/pages/App/Theme';

export const AccordionDetails = styled(AccordionDetailsMui)`
  border-left: 1px solid ${COLOR_BORDER};
  margin-left: ${theme.spacing(1.5)};
  padding-left: ${theme.spacing(1.5)};
`;
